export enum DirectSignUpLandingOrder {
  'SignUpOptions',
  'ResponsibleSocialPlay',
  'SignUpRegister',
  'EmailVerification',
  'VerificationSuccess',
  'WelcomeBonusDialog',
  'ChooseCountry',
}

export enum DirectEmailLandingOrder {
  'SignUpEmailLanding',
  'ResponsibleSocialPlay',
  'EmailVerification',
  'VerificationSuccess',
  'WelcomeBonusDialog',
  'ChooseCountry',
}

export enum SignupWizardOrder {
  'SignUpPrivacy',
  'ResponsibleSocialPlay',
  'SignUpOptions',
  'SignUpRegister',
  'EmailVerification',
  'VerificationSuccess',
  'WelcomeBonusDialog',
  'ChooseCountry',
}
